import { Injectable } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { NgbAlertModule, NgbModalModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CookieService } from 'ngx-cookie-service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { ErrorMessageComponent } from 'app/shared/components/error-message/error-message.component';
import { AuthenticationService } from 'app/shared/services/authentication-service';
import { AdminGuard } from 'app/shared/services/admin-guard.service';

import { LayoutComponent } from 'app/shared/components/layout/layout.component';
import { SwitchComponent } from 'app/shared/components/switch/switch.component';
import { NavigationbarComponent } from 'app/shared/components/navigation-bar/navigation-bar.component';
import { HeaderTitleComponent } from 'app/shared/components/header-title/header-title.component';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { ConfirmationMessageComponent } from 'app/shared/components/confirmation-message/confirmation-message.component';
import { CompanyFilterComponent } from 'app/shared/components/company-filter/company-filter.component';

import { ChartComponent } from 'app/shared/components/chart/chart.component';
import { ChartRatingPCComponent } from 'app/shared/components/chart-rating-pc/chart-rating-pc.component';
import { ChartCompletedPCComponent } from 'app/shared/components/chart-completed-pc/chart-completed-pc.component';
import { ChartDaysToCompletedComponent } from 'app/shared/components/chart-days-to-complete/chart-days-to-complete.component';
import { ChartRatingsPerMonthComponent } from 'app/shared/components/chart-rating-pm/chart-rating-pm.component';
import { ChartQtyPerMonthComponent } from 'app/shared/components/chart-qty-pm/chart-qty-pm.component';
import { ChartBrokerModuleQtyComponent } from 'app/shared/components/chart-broker-module-qty/chart-broker-module-qty.component';

import { DatepickerDirective } from 'app/shared/directives/datepicker.directive';
import { DatepickerMonthYearDirective } from 'app/shared/directives/datepicker-month-year.directive';
import { DatepickerDayMonthDirective } from 'app/shared/directives/datepicker-day-month.directive';
import { CalendarDirective } from 'app/shared/directives/calendar.directive';
import { MaskDirective } from 'app/shared/directives/mask.directive';
import { ToggleDirective } from 'app/shared/directives/toggle.directive';
import { SortableTableDirective } from 'app/shared/directives/sortable-table.directive';
import { Select2Directive } from 'app/shared/directives/select2.directive'

import { HighlightPipe } from 'app/shared/pipes/highlight.pipe';
import { HtmlToTextPipe } from 'app/shared/pipes/htmlToText.pipe';
import { TruncatePipe } from 'app/shared/pipes/truncate.pipe';
import { ParentFilterPipe } from 'app/shared/pipes/parentFilter.pipe';

import { SharedService } from 'app/shared/services/shared.service';
import { DropzoneModule, DropzoneConfigInterface, DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
//import { ScriptLoaderService } from 'app/shared/services/script-loader.service';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    // Change this to your upload POST address:
    //url: 'https://httpbin.org/post',
    acceptedFiles: '.xlsx, .xls, .pdf, .png, .jpg, .jpeg, .doc, .dox, .xls, .xlsx'
    //createImageThumbnails: false
};

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        NgbAlertModule,
        NgSelectModule,
        NgbModalModule,
        NgbDatepickerModule,
		CKEditorModule,
        DropzoneModule,
        NgxChartsModule,
        BrowserModule,
        BrowserAnimationsModule,
        DragDropModule,
        PerfectScrollbarModule,
        BsDatepickerModule.forRoot()
    ],
    declarations: [
        ErrorMessageComponent,
        LayoutComponent,
        SwitchComponent,
        DatepickerDirective,
        DatepickerMonthYearDirective,
        DatepickerDayMonthDirective,
        CalendarDirective,
        MaskDirective,
        ToggleDirective,
        Select2Directive,
        HighlightPipe,
        HtmlToTextPipe,
        TruncatePipe,
        ParentFilterPipe,
        SortableTableDirective,
        NavigationbarComponent,
        HeaderTitleComponent,
        AlertMessageComponent,
        ConfirmationMessageComponent,
        ChartComponent,
        ChartRatingPCComponent,
        ChartCompletedPCComponent,
        ChartDaysToCompletedComponent,
        ChartRatingsPerMonthComponent,
        ChartQtyPerMonthComponent,
        ChartBrokerModuleQtyComponent,
        CompanyFilterComponent
    ],
    exports: [
        FormsModule,
        NgSelectModule,
        NgbAlertModule,
        NgbModalModule,
        NgbDatepickerModule,
        DropzoneModule,
        ReactiveFormsModule,
        CommonModule,
        HttpClientModule,
        ErrorMessageComponent,
        LayoutComponent,
        BrowserAnimationsModule,
        SwitchComponent,
        DatepickerDirective,
        DatepickerMonthYearDirective,
        DatepickerDayMonthDirective,
        CalendarDirective,
        MaskDirective,
        ToggleDirective,
        Select2Directive,
        HighlightPipe,
        HtmlToTextPipe,
        TruncatePipe,
        ParentFilterPipe,
        SortableTableDirective,
        NavigationbarComponent,
        HeaderTitleComponent,
        AlertMessageComponent,
		CKEditorModule,
        ConfirmationMessageComponent,
        ChartComponent,
        ChartRatingPCComponent,
        ChartCompletedPCComponent,
        ChartDaysToCompletedComponent,
        ChartRatingsPerMonthComponent,
        ChartQtyPerMonthComponent,
        ChartBrokerModuleQtyComponent,
        NgxChartsModule,
        BrowserAnimationsModule,
        DragDropModule,
        PerfectScrollbarModule,
        CompanyFilterComponent,
        BsDatepickerModule
    ],
    providers: [
        //ScriptLoaderService,
        AuthenticationService,
        AdminGuard,
        DatePipe,
        HtmlToTextPipe,
        CookieService,
        SharedService,
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG,
        },
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ],
    entryComponents: [
        CompanyFilterComponent
    ]
})
@Injectable()
export class SharedModule {
}
